 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import LOVE_1 from '@/components/love_1'
 import TITLEPAGE from '@/components/title-page'
 import COPYRIGHT from '@/components/copyright'
 import CONTENTS from '@/components/contents'
 import PRAISEFORRUBYSOAMES from '@/components/praise-for-ruby-soames'
 import NEWSLETTERSIGNUP from '@/components/newsletter-sign-up'
 import DEDICATION from '@/components/dedication'
 import CHAPTER001 from '@/components/chapter-001'
 import FRIDAY from '@/components/friday'
 import CHAPTER002 from '@/components/chapter-002'
 import SATURDAY from '@/components/saturday'
 import CHAPTER003 from '@/components/chapter-003'
 import SUNDAY from '@/components/sunday'
 import CHAPTER004 from '@/components/chapter-004'
 import MONDAY from '@/components/monday'
 import CHAPTER005 from '@/components/chapter-005'
 import TUESDAY from '@/components/tuesday'
 import CHAPTER006 from '@/components/chapter-006'
 import WEDNESDAY from '@/components/wednesday'
 import CHAPTER007 from '@/components/chapter-007'
 import THURSDAY from '@/components/thursday'
 import CHAPTER008 from '@/components/chapter-008'
 import LOVE_2 from '@/components/love_2'
 import NEWSLETTERSIGNUP2 from '@/components/newsletter-sign-up-2'
 import YOUWILLALSOENJOY from '@/components/you-will-also-enjoy'
 import ACKNOWLEDGEMENTS from '@/components/acknowledgements'
 import ABOUTTHEAUTHOR from '@/components/about-the-author'
 import ANOTEFROMTHEPUBLISHER from '@/components/a-note-from-the-publisher'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/title-page",
 			"name" : "title-page",
 			"component" : TITLEPAGE
 		},
 		{
 			"path" : "/copyright",
 			"name" : "copyright",
 			"component" : COPYRIGHT
 		},
 		{
 			"path" : "/contents",
 			"name" : "contents",
 			"component" : CONTENTS
 		},
 		{
 			"path" : "/praise-for-ruby-soames",
 			"name" : "praise-for-ruby-soames",
 			"component" : PRAISEFORRUBYSOAMES
 		},
 		{
 			"path" : "/newsletter-sign-up",
 			"name" : "newsletter-sign-up",
 			"component" : NEWSLETTERSIGNUP
 		},
 		{
 			"path" : "/dedication",
 			"name" : "dedication",
 			"component" : DEDICATION
 		},
 		{
 			"path" : "/chapter-001",
 			"name" : "chapter-001",
 			"component" : CHAPTER001
 		},
 		{
 			"path" : "/friday",
 			"name" : "friday",
 			"component" : FRIDAY
 		},
 		{
 			"path" : "/chapter-002",
 			"name" : "chapter-002",
 			"component" : CHAPTER002
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js